import { render, staticRenderFns } from "./PreviewWheel.vue?vue&type=template&id=395e6978&scoped=true"
import script from "./PreviewWheel.vue?vue&type=script&lang=js"
export * from "./PreviewWheel.vue?vue&type=script&lang=js"
import style0 from "./PreviewWheel.vue?vue&type=style&index=0&id=395e6978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e6978",
  null
  
)

export default component.exports